import { render, staticRenderFns } from "./AcceptEvaluationTable.vue?vue&type=template&id=824c8154"
import script from "./AcceptEvaluationTable.vue?vue&type=script&lang=js"
export * from "./AcceptEvaluationTable.vue?vue&type=script&lang=js"
import style0 from "./AcceptEvaluationTable.vue?vue&type=style&index=0&id=824c8154&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports